import React from 'react'
import { styled, useTheme } from '@mui/material'
import { EmailVerification } from './EmailVerification'

export const MODAL_ID = 'MODAL/NO_TEMPLATE_EMAIL_VERIFICATION'

const NoTemplateWrapper = styled('div')(({ theme }) => ({
  maxWidth: '400px',
  margin: '32px',
  width: '400px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
    width: '100%',
    marginTop: '96px',
  },
}))

const Title = styled('h2')(() => ({
  fontWeight: 500,
  fontSize: '25px',
  marginBottom: '16px',
}))

export const NoTemplateEmailVerification = () => {
  const theme = useTheme()
  return (
    <NoTemplateWrapper>
      <Title>Email Verification</Title>
      <EmailVerification noTemplate />
    </NoTemplateWrapper>
  )
}
